import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from ".././axios-interceptor";
import { ThreeDots } from "react-loader-spinner";

import {
  base_url,
  LOAN_CURRENCY_TYPE_BHD,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_APPROVED,
  STATUS_PROCESSED,
} from "./../utilities";
import {
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
} from "./../utilities";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import ModalFooter from "./ModalFooter";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
// Extend Tenure / Preclosure / Partial Prepayment are not supported for multi-investor (Fund Now)
// loans yet; those loans (is_multi_investor from get_loan_trx_user) are left out of the pickers.
const MULTI_INVESTOR_NOTE = "Not available for multi-investor loans — contact BenneFin";
const hasMultiInvestorLoan = (loans) =>
  Array.isArray(loans) && loans.some((l) => l && l.is_multi_investor && l.status == STATUS_PROCESSED);

const NewServiceRequest = (props) => {
  const navigate = useNavigate();
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
  const [selectedServiceTypeCode, setSelectedServiceTypeCode] = useState(
    SERVICE_REQUEST_EXTEND_TENURE
  );
  const [download, setDownload] = useState([]);
  const [loandata, setLoanData] = useState([]);
  const [loanrefnum, setLoanRefNum] = useState([]);
  const [datevalue, setDatevalue] = useState();
  const [servicetype, setServiceType] = useState([]);
  const [preloanrefnum, setPreLoanRefNum] = useState([]);
  const [prepaymentRefNum, setPrepaymentRefNum] = useState([]);

  useEffect(() => {
    axios
      .post(base_url + "service-type-master/get_service_type")
      .then((res) => {
        setServiceType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(base_url + "loan-trx/get_loan_trx_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        const data = res.data.data;
        if (data) {
          setLoanData(data);
        } else {
          setLoanData("No Data Found");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(base_url + "documents-type/get_document_types", {})
      .then((res) => {
        let doctypes = res.data.data;
        let x = [];
        doctypes.SERVICE_REQUESTS.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
        setDownload(x);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
const [isLoading, setIsLoading] = useState(false)
  
  const handleSubmit = () => {
    let selectedobjData = filteredLoanRef[0];
    const fd = new FormData();
    fd.append('loan_documents', [])
    fd.append('service_type_code', SERVICE_REQUEST_EXTEND_TENURE)
    fd.append('business_id', selectedobjData?.business_id)
    fd.append('user_id', selectedobjData?.user_id)
    fd.append('loan_id', selectedobjData?.loan_id)
    fd.append('loan_type_id', selectedobjData?.loan_type_id)
    fd.append('loan_purpose', selectedobjData?.loan_purpose)
    fd.append('loan_amount', selectedobjData?.loan_amount)
    fd.append('loan_currency', selectedobjData?.admin_request_loan_currency)
    fd.append('loan_tenure', selectedobjData?.loan_tenure)
    fd.append('monthly_profit_rate', "" + selectedobjData?.bennefin_roi)
    fd.append('principal_frequency', "" + selectedobjData?.principal_frequency)
    fd.append('loan_reference_number', selectedobjData?.loan_reference_number)
    fd.append('extend_tenure', datevalue)
    fd.append('created_by', Cookies.get("user_name"))
    fd.append('notes', textarea)
    fd.append('status', selectedobjData?.status)
    documents_lst.forEach(elem => {
      if(elem.document_url){
      const fileName = elem.document_url.name;
      const lastDotIndex = fileName.lastIndexOf('.');
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fd.append('file', elem.document_url, elem.document_type+"."+fileExtension);
      }
    })

    if (
      SERVICE_REQUEST_EXTEND_TENURE == null ||
      selectedobjData?.loan_reference_number== null
    ) {
      toast.error("Please select all mandatory fields", {
        toastId: 8,
      });
    }
  
    // else if (
    //   newServiceObj.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    // ) {
      else if (
        datevalue == null ||
        datevalue == "Select" ||
        datevalue == ""
      ) {
        toast.error("Please select extend tenure duration", {
          toastId: 10,
        });
      } else {
        setIsLoading(true)
        axios
          .post(
            base_url + "service-request-trx/save_new_service_request_trx",
            fd
          )
          .then((res) => {
            setIsLoading(false)
            // Backend returns 400 for all block cases
            if (res.data.status === 400) {
              toast.error(res.data.message, { toastId: 4 });
              return
            }
            // Legacy 200 checks for older message formats
            if (
              res.data.message === "Already Raised Extend Tenure" ||
              res.data.message === "Already raised extend tenure" ||
              res.data.message?.toLowerCase().includes('already raised extend tenure')
            ) {
              toast.error("A request for extend tenure has already been raised", { toastId: 4 });
              return
            }
            if (
              res.data.message === "Already Raised Pre Closure" ||
              res.data.message?.toLowerCase().includes('already raised pre closure')
            ) {
              toast.error("A request for pre-closure has already been raised", { toastId: 4 });
              return
            }
            // Success
            props.onHide();
            toast.success("Service request created successfully", { toastId: 4 });
            setTimeout(() => {
              window.location.reload();
            }, 800);
          })
          .catch((err) => {
            if (err.response?.data?.message) {
              toast.error(err.response.data.message, { toastId: 4 })
            }
            console.log(err);
          })
          .finally(() => setIsLoading(false));
      }
  };

  let serviceTypeName = [];

  {
    servicetype.map((s_type, index) => {
      if (s_type.service_type_code != null) {
        serviceTypeName.push(s_type.service_type_name);
      }
    });
  }

  const [extendtenure, setExtendTenure] = useState("d-block");
  const [partialPrePayment, setPartialPrePayment] = useState("d-none");
  const [preclosure, setPreClosure] = useState("d-none");
  const [textarea, setTextarea] = useState("");

  const handleChangeInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name == "loanrefno") {
      setLoanRefNum(value);
    }
    if (name == "textarea") {
      setTextarea(value);
    }
    if (name == "date") {
      setDatevalue(value.split(" ")[0]);
    }
    if (value == "Select") {
      if (name == "loanrefno") {
        setLoanRefNum(null);
        setTextarea("");
        setDatevalue(null);
      }
    }
    if (name == "date") {
    }
  };

  let documents_lst = [];
  download.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null)
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
      });
  });

  let filteredLoanRef = [];

  {
    loandata.map((ldata) => {
      if (loanrefnum == ldata.loan_reference_number) {
        if (loanrefnum != undefined) {
          filteredLoanRef.push(ldata);
        } else {
          filteredLoanRef.push("-");
        }
      }
    });
  }



  const handleChange = (event, item) => {

    if (event.target.files[0].size < 5242880) {
      let sample_download = [...download];
      sample_download.forEach((doc) => {
        if (doc.doc_type == item.doc_type) {
          item.is_upload = true;
          doc.is_upload = true;
          doc.document_type = item.doc_type;
          doc.document_url = event.target.files[0];
          doc.file_name = event.target.files[0].name;
        }
      });
      setDownload(sample_download);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  }

  let months = [];
  for (let i = 1; i <= 3; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }

  const handleClose = () => {
    setExtendTenure("d-block");
    setPartialPrePayment("d-none");
    setPreClosure("d-none");
    props.onHide();
    months.push();
    setLoanRefNum();
    setPrepaymentRefNum()
    setTextarea();
    setDatevalue();
    download.forEach((doc) => {
      doc.is_upload = false;
      delete doc.document_type;
      delete doc.document_url;
    });
  };


  let formattedNumber = [];
  if (loanrefnum != null && loanrefnum != "") {
    const number = Number(filteredLoanRef[0]?.loan_amount);
    formattedNumber = number != undefined ? number.toLocaleString() : "";
  }
  const handleChangeDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(file.document_url);
    window.open(fileUrl, '_blank');
  }
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header onHide={handleClose} closeButton>
        <Modal.Title id="contained-modal-title-vcenter p-1">
          <h6 className="mb-0">New Service Request</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal_body px-3">
      <div className={ isLoading ?"onClickApplyLoaderStyl" :'d-none'}>
        <div>
          <ThreeDots
          height="90"
          width="90"
          radius="9"
          color="#3d79f3"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={isLoading}
              />
        </div><br/>
      </div>
         { isLoading ? <div className="loader_style">Saving...</div>:''}
        <ServiceType
          months={months}
          setDatevalue={setDatevalue}
          setExtendTenure={setExtendTenure}
          setPartialPrePayment={setPartialPrePayment}
          setPreClosure={setPreClosure}
          setLoanRefNum={setLoanRefNum}
          servicetype={servicetype}
          setSelectedServiceTypeCode={setSelectedServiceTypeCode}
          setPreLoanRefNum={setPreLoanRefNum}
          setPrepaymentRefNum={setPrepaymentRefNum}
        />

        <div className={extendtenure}>
          <div className="">
            <h6 className="mb-0 mt-3">Current Loan Details</h6>
            <div className="row d-flex gap-1 row-cols-4">
              <div className="col-lg ">
                <label htmlFor="loanrefno">
                  <p>
                    Loan Reference No. <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <select
                  id="loanrefno"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loanrefno"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option>Select</option>
                  {selectedServiceTypeCode == SERVICE_REQUEST_EXTEND_TENURE ? (
                    loandata.map((l_data) => {
                      // "At least one installment paid" check removed as a hotfix so bullet loans can be extended
                      if (l_data.status == STATUS_PROCESSED && l_data.is_extend_tenure_raised == 0 && !l_data.is_multi_investor) {
                        return (
                          <option key={l_data.loan_id}>
                            {l_data.loan_reference_number}
                          </option>
                        );
                      }
                    })
                  ) : (
                   ''
                  )}
                </select>
                {hasMultiInvestorLoan(loandata) && (
                  <p style={{ fontSize: 11.5, color: "#7C8495", marginTop: 4, marginBottom: 0 }}>
                    {MULTI_INVESTOR_NOTE}
                  </p>
                )}
              </div>

              <form className="col-lg-2 m-2 mt-0">
                <label htmlFor="loantype">
                  <p>Loan Type</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={filteredLoanRef[0]?.loan_type_name}
                />
              </form>

              <form className="col-lg-2 m-2 mt-0">
                <label htmlFor="loanamount">
                  <p>Loan Amount</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={
                    formattedNumber.length != 0
                      ? (filteredLoanRef[0]?.admin_request_loan_currency ===
                        LOAN_CURRENCY_TYPE_BHD
                        ? LOAN_CURRENCY_TYPE_BHD + " "
                        : "$\u00A0") + formattedNumber
                      : ""
                  }
                />
              </form>

              <form className="col-md m-2 mt-0">
                <label htmlFor="tenure">
                  <p>Tenure</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control"
                  placeholder={`${filteredLoanRef[0]?.admin_request_loan_tenure != undefined
                    ? filteredLoanRef[0]?.admin_request_loan_tenure +
                    (filteredLoanRef[0]?.admin_request_loan_tenure == 1
                      ? " Month"
                      : " Months")
                    : ""
                    }`}
                />
              </form>

              <form className="col-lg-2 m-2 mt-0">
                <label htmlFor="loanpurpose">
                  <p>Loan Purpose</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control LA_custm_styl"
                  placeholder={filteredLoanRef[0]?.loan_purpose}
                />
              </form>

              <form className="col-md m-2 mt-0">
                <label htmlFor="monthlyprofitrate">
                  <p>Monthly Rate</p>
                </label>
                <input
                  disabled
                  type="text"
                  id="disabledTextInput"
                  className="form-control select_custom_style"
                  placeholder={
                    filteredLoanRef[0]?.bennefin_roi === undefined
                      ? ""
                      :  filteredLoanRef[0]?.bennefin_roi + "%"
                  }
                />
              </form>
            </div>
          </div>

          <div className="row">
            <h3 className="mb-0 mt-2">Requested Tenure Extension</h3>

            <div className="col-lg-9">
              <div className="row gap-3">
                <div className="col-lg-2">
                  <label htmlFor="amountpayable">
                    <p>Amount Payable</p>
                  </label>
                  <input
                    disabled
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder={
                      filteredLoanRef[0]?.amount_payable != undefined
                        ? (filteredLoanRef[0]?.admin_request_loan_currency ===
                          LOAN_CURRENCY_TYPE_BHD
                          ? LOAN_CURRENCY_TYPE_BHD + " "
                          : "$\u00A0") + filteredLoanRef[0]?.amount_payable
                        : ""
                    }
                  />
                </div>

                <div className="col-lg-3">
                  <label htmlFor="amountpayable">
                    <p>Actual Tenure Date</p>
                  </label>
                  <input
                    disabled
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder={
                      filteredLoanRef[0] != null
                        ? moment(
                          filteredLoanRef[0]?.my_payment_schedules[
                            filteredLoanRef[0].my_payment_schedules.length - 1
                          ].tenure_date
                        ).format("DD MMM YYYY")
                        : ""
                    }
                  />
                </div>

                <div className="col-md-3 ">
                  <label htmlFor="date">
                    <p>
                      Extended Tenure in months{" "}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                  </label>
                  <select
                    id="date"
                    name="date"
                    className="form-select  APNL_option_flds shadow-ben"
                    aria-label="form-select example"
                    onChange={handleChangeInput}
                  >
                    <option>Select</option>
                    {selectedServiceTypeCode ==
                      SERVICE_REQUEST_EXTEND_TENURE ? (
                      months.map((mnths, index) => {
                        return (
                          <option key={index}>
                            {`${mnths}  ${mnths == 1 ? " Month" : " Months"}`}
                          </option>
                        );
                      })
                    ) : (
                      <option>Select</option>
                    )}
                  </select>
                </div>
              </div>

              <div>
                <h6 className="mt-2">Reason for Extension</h6>
                <Form>
                  <Form.Group className=" " controlId="floatingTextarea">
                    <Form.Control
                      size="sm"
                      className="ANLtextarea "
                      name="textarea"
                      as="textarea"
                      style={{ height: "50px", width: "95%" }}
                      rows={2}
                      placeholder="Please mention the reason for extending your tenture date."
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                </Form>
              </div>
            </div>

            <div className="col p-3 bg-light rounded-3">
              <h3 style={{ marginLeft: "16px" }}>Break-up of Total Loan</h3>
              <ul>
                <li>
                  Principal Amount
                  <br />
                  <p>
                    {filteredLoanRef[0]?.loan_amount != undefined
                      ? (filteredLoanRef[0]?.admin_request_loan_currency ===
                        LOAN_CURRENCY_TYPE_BHD
                        ? LOAN_CURRENCY_TYPE_BHD + " "
                        : "$\u00A0") + filteredLoanRef[0]?.loan_amount
                      : "-"}
                  </p>
                </li>
                <li className="mt-2">
                  Tenure Period and Amount <br />
                  <p>
                    {filteredLoanRef[0]?.total_repaid != undefined
                      ? `${filteredLoanRef[0]?.admin_request_loan_tenure !=
                        undefined
                        ? filteredLoanRef[0]?.admin_request_loan_tenure +
                        (filteredLoanRef[0]?.admin_request_loan_tenure ==
                          1
                          ? " Month  "
                          : " Months  ")
                        : ""
                      } ` +
                      "-  " +
                      (filteredLoanRef[0]?.admin_request_loan_currency ===
                        LOAN_CURRENCY_TYPE_BHD
                        ? LOAN_CURRENCY_TYPE_BHD + " "
                        : "$\u00A0") +
                      filteredLoanRef[0]?.total_repaid
                      : "-"}{" "}
                  </p>
                </li>
              </ul>
            </div>

            <div className="mt-xxl-3 mt-md-2">
              <h6 className="">
                Upload Documents
                <span className="gray-text fw-bolder">(Optional)</span>
                <span style={{ color: "red" }}>
                  {" "}
                  ( File size should be less than 5MB *)
                </span>
              </h6>
              <p>
                Please upload any documents relevant to this loan, including any
                invoices, checks, or other documents.
              </p>
              <div className="upload_cls col ">
                {download.map((item) => {
                  return (
                    <div key={item.doc_type} className="row ">
                      <div className="col-lg-3 text-start  text-wrap">
                        <article>{item.doc_type}</article>
                      </div>
                      <div className="col-lg-2">
                        <label className="d-flex">
                          <img
                            src="./images/icons/plus_symbol.svg"
                            alt="UploadFile"
                          />
                          <span className="me-3 text-start">
                            {" "}
                            {!item.is_upload ? "Upload File" : " Uploaded"}
                          </span>
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) => handleChange(e, item)}
                          />
                        </label>
                      </div>

                      <div className="col-lg-5 ">
                        {item.is_upload ? (
                          <div>
                            <span>
                              <a
                                style={{ display: "table-cell", cursor: "pointer" }}
                              >
                                
                                <i
                                  className="fa-solid fa-eye text-primary fa-eye-font"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Click to view image"
                                  onClick={(e) => handleChangeDownload(e, item)}
                                />
                              </a>{" "}
                              <span className="input_filname">
                                {" "}
                                {item.file_name}
                              </span>
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className=" col-lg-6 mt-3"></div>
              </div>
            </div>
          </div>
          <ModalFooter handleClose={handleClose} handleSubmit={handleSubmit} isLoading={isLoading}/>
        </div>

        <div className={preclosure}>
          <PreClosureofLoan
            download={download}
            servicetype={servicetype}
            setPreLoanRefNum={setPreLoanRefNum}
            preloanrefnum={preloanrefnum}
            handleClose={handleClose}
            servicecode={selectedServiceTypeCode}
            loandata={loandata}
          />
        </div>
        <div className={partialPrePayment}>
          <PartialPrePayment
            download={download}
            servicetype={servicetype}
            setPrepaymentRefNum={setPrepaymentRefNum}
            prepaymentRefNum={prepaymentRefNum}
            handleClose={handleClose}
            servicecode={selectedServiceTypeCode}
            loandata={loandata}
          />
          </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewServiceRequest;

export const PartialPrePayment = (props) => {
  let servicetype = props.servicetype;
  let download = props.download;
  let setPrepaymentRefNum = props.setPrepaymentRefNum;
  const [prepaymentAmt, setPrepaymentAmt] = useState([])
  let prepaymentRefNum = props.prepaymentRefNum;
  let serviceCode = props.servicecode;
  let preLoandata = props.loandata;
  const [prePaymentDate, setPrePaymentDate] = useState();
  const handleChangeInputDate = (e) => {

    var datum = Date.parse(e.target.value);
    setPrePaymentDate(datum);
  };
const [isLoading, setIsLoading] = useState(false)

  const handlePreSubmit = () => {
    if (
      newServiceObj.service_type_code == null ||
      newServiceObj.loan_reference_number == null ||
      serviceCode != SERVICE_REQUEST_PARTIAL_PRE_PAYMENT || newServiceObj.partial_prepayment_date == null ||
      newServiceObj.partial_prepayment_amount == null
    ) {
      toast.error("Please select all mandatory fields", {
        toastId: 8,
      });
    }
    
    // else if (
    //   newServiceObj.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    // ) {
    //   if (
    //     newServiceObj.extend_tenure == null ||
    //     newServiceObj.extend_tenure == ""
    //   ) {
    //     toast.error("Please select extend tenure duration", {
    //       toastId: 10,
    //     });
    //   }
    // }
    
    else {
      axios
        .post(
          base_url + "service-request-trx/save_new_service_request_trx",
          newServiceObj
        )
        .then((res) => {
          if (res.data.message == "Already raised extend tenure") {
            toast.error("A request for extend tenure has already been raised", {
              toastId: 4,
            });
          } 
          else if (res.data.message == "Already Raised Pre Closure") {
            toast.error("A request for pre-closure has already been raised", {
              toastId: 5,
            });
          } 
          else if (res.data.message == "Already Raised Partial Pre-Payment") {
            toast.error("A request for partial prepayment has already been raised", {
              toastId: 6,
            });
          } 
          else {
            setIsLoading(true)
            toast.success("Service request created successfully", {
              toastId: 3,
            });
            props.handleClose();
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  let serviceTypeName = [];

  {
    servicetype.map((s_type, index) => {
      if (s_type.service_type_code != null) {
        serviceTypeName.push(s_type.service_type_name);
      }
    });
  }

  const [textarea, setTextarea] = useState("");



  let documents_lst = [];
  download.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null)
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
      });
  });

  let PreloanfilteredLoanRef = [];

  {
    preLoandata.map((ldata) => {
      if (prepaymentRefNum == ldata.loan_reference_number) {
        if (prepaymentRefNum !== undefined) {
          PreloanfilteredLoanRef.push(ldata);
        } else {
          PreloanfilteredLoanRef.push("-");
        }
      }
    });
  }

  let selectedobjData = PreloanfilteredLoanRef[0];
  let newServiceObj = {
    loan_documents: documents_lst,
    service_type_code: SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
    business_id: selectedobjData?.business_id,
    user_id: selectedobjData?.user_id,
    loan_id: selectedobjData?.loan_id,
    loan_type_id: selectedobjData?.loan_type_id,
    loan_purpose: selectedobjData?.loan_purpose,
    loan_amount: selectedobjData?.loan_amount,
    loan_currency: selectedobjData?.admin_request_loan_currency,
    loan_tenure: selectedobjData?.loan_tenure,
    monthly_profit_rate: "" + selectedobjData?.bennefin_roi,
    principal_frequency: "" + selectedobjData?.principal_frequency,
    loan_reference_number: selectedobjData?.loan_reference_number,
    extend_tenure: 0,
    created_by: Cookies.get("user_name"),
    notes: textarea,
    partial_prepayment_date:prePaymentDate,
    partial_prepayment_amount: prepaymentAmt

  };
  const handleChangeInput = (e) => {
    const { target } = e;
    const value = target.value;
    if (e.target.name == "loanrefno") {
      setPrepaymentRefNum(e.target.value);
    }
    if (e.target.name == "textarea") {
      setTextarea(e.target.value);
    }
    if (e.target.value == "Select") {
      setPrepaymentRefNum(null);
      setTextarea("");
    }
    if (e.target.name == "prepaymentAmt") {
      if( value > Number(PreloanfilteredLoanRef[0].loan_amount))
        {
          toast.error("Amount should be less than loan amount", {
            toastId: 12,
          });
          target.value = null
          setPrepaymentAmt("")
        }
      if(e.target.value === undefined ){
        
        setPrepaymentAmt("")
      }
      setPrepaymentAmt(e.target.value);
      
    }
  };
  const today = new Date().toISOString().substr(0, 10);

  return (
    <>
    
      <div className="row ">
      
        <div className="">
          <h6 className="mb-0 mt-2">Current Loan Details</h6>
          <div className="row d-flex gap-1 row-cols-3">
            <div className="col-lg-2 m-2">
              <label htmlFor="loanrefno">
                <p>
                  Loan Reference No.<span style={{ color: "red" }}>*</span>
                </p>
              </label>
              <select
                id="loanrefno"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="loanrefno"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option>Select</option>
                {serviceCode == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT ? (
                  preLoandata.map((l_data) => {
                    if (l_data.status == STATUS_PROCESSED && l_data.is_partial_prepayment_raised == 0 && !l_data.is_multi_investor) {
                      return (
                        <option key={l_data.loan_id}>
                          {l_data.loan_reference_number}
                        </option>
                      );
                    }
                  })
                ) : (
                  <option>Select</option>
                )}
              </select>
              {hasMultiInvestorLoan(preLoandata) && (
                <p style={{ fontSize: 11.5, color: "#7C8495", marginTop: 4, marginBottom: 0 }}>
                  {MULTI_INVESTOR_NOTE}
                </p>
              )}
            </div>
            <div className="col-lg-3 m-2">
              <label htmlFor="loantype">
                <p>Loan Type</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={PreloanfilteredLoanRef[0]?.loan_type_name}
              />
            </div>
            <form className="col-lg m-2">
              <label htmlFor="loanamount">
                <p>Loan Amount</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={
                  PreloanfilteredLoanRef[0]?.loan_amount !== undefined
                    ? PreloanfilteredLoanRef[0]?.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                      ? "BHD " +
                      PreloanfilteredLoanRef[0]?.loan_amount
                      : "$\u00A0" + PreloanfilteredLoanRef[0]?.loan_amount
                    : "-"
                }
              />
            </form>
            <form className="col-sm-3 m-2">
              <label htmlFor="tenure">
                <p>Tenure</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={`${PreloanfilteredLoanRef[0]?.admin_request_loan_tenure !=
                  undefined
                  ? PreloanfilteredLoanRef[0]?.admin_request_loan_tenure +
                  (PreloanfilteredLoanRef[0]?.admin_request_loan_tenure == 1
                    ? " Month"
                    : " Months")
                  : ""
                  }`}
              />
            </form>
            <form className="col-lg-3 m-2">
              <label htmlFor="loanpurpose">
                <p>Loan Purpose</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={
                  PreloanfilteredLoanRef[0]?.loan_purpose != undefined
                    ? PreloanfilteredLoanRef[0].loan_purpose
                    : ""
                }
              />
            </form>
            <form className="col-lg-2 m-2">
              <label htmlFor="monthlyprofitrate">
                <p>Monthly Rate</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control select_custom_style"
                placeholder={
                  PreloanfilteredLoanRef[0]?.bennefin_roi != null
                    ? PreloanfilteredLoanRef[0]?.bennefin_roi + "%"
                    : ""
                }
              />
            </form>
            <form className="col-lg-2 m-2">
              <label htmlFor="monthlyprofitrate">
                <p>Partial Prepayment Amount<span style={{ color: "red" }}>*</span></p>
              </label>
              <input
                name='prepaymentAmt'
                type="number"
                id="disabledTextInput"
                className="form-control select_custom_style"
                onChange={handleChangeInput}

              />
            </form>
            <form className="col-lg-2 m-2">
              <label htmlFor="paiddate">
                <p>
                  Partial Prepayment Date <span style={{ color: "red" }}>*</span>
                </p>
              </label>
              <input
                name="paiddate"
                id="paiddate"
                type="date"
                min={today}
                className="form-control select_custom_style"
                onChange={handleChangeInputDate}
              />
            </form>

            


          </div>
        </div>
        <div>
          <h6 className="mb-1">Notes</h6>
          <Form className="mb-5">
            <Form.Group className=" " controlId="exampleForm.ControlTextarea1">
              <Form.Control
                size="sm"
                className="ANLtextarea"
                name="textarea"
                as="textarea"
                rows={2}
                placeholder="Please Enter your comments for any special requests or providing information to the Admin"
                onChange={handleChangeInput}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
      <Modal.Footer className="prefooter">
        <button
          className="btn gray_btn px-3 py-1"
          variant="secondary"
          onClick={props.handleClose}
        >
          Close
        </button>
        <button
          className="btn blue_btn px-3 py-1"
          variant="primary"
          onClick={handlePreSubmit}
        >
          Send Prepayment Request
        </button>
      </Modal.Footer>
    </>
  );
};
export const PreClosureofLoan = (props) => {
  let servicetype = props.servicetype;
  let download = props.download;
  let setPreLoanRefNum = props.setPreLoanRefNum;
  let preloanrefnum = props.preloanrefnum;
  let serviceCode = props.servicecode;
  let preLoandata = props.loandata;
  const [preClosureDate, setPreclosureDate] = useState();
  const handleChangeInputDate = (e) => {
    var datum = Date.parse(e.target.value);
    setPreclosureDate(datum);
  };
const [isLoading, setIsLoading] = useState(false)

  const handlePreSubmit = () => {
    if (
      newServiceObj.service_type_code == null ||
      newServiceObj.loan_reference_number == null ||
      serviceCode != SERVICE_REQUEST_PRE_CLOSURE || newServiceObj.preclosure_date == null
    ) {
      toast.error("Please select all mandatory fields", {
        toastId: 8,
      });
    } else if (
      newServiceObj.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      if (
        newServiceObj.extend_tenure == null ||
        newServiceObj.extend_tenure == ""
      ) {
        toast.error("Please select extend tenure duration", {
          toastId: 10,
        });
      }
    } else {
      axios
        .post(
          base_url + "service-request-trx/save_new_service_request_trx",
          newServiceObj
        )
        .then((res) => {
          if (res.data.message == "Already raised extend tenure") {
            toast.error("A request for extend tenure has already been raised", {
              toastId: 4,
            });
          } else if (res.data.message == "Already Raised Pre Closure") {
            toast.error("A request for pre-closure has already been raised", {
              toastId: 4,
            });
          } else {
            setIsLoading(true)
            toast.success("Service request created successfully", {
              toastId: 4,
            });
            props.handleClose();
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  let serviceTypeName = [];

  {
    servicetype.map((s_type, index) => {
      if (s_type.service_type_code != null) {
        serviceTypeName.push(s_type.service_type_name);
      }
    });
  }

  const [textarea, setTextarea] = useState("");

  const handleChangeInput = (e) => {
    if (e.target.name == "loanrefno") {
      setPreLoanRefNum(e.target.value);
    }
    if (e.target.name == "textarea") {
      setTextarea(e.target.value);
    }
    if (e.target.value == "Select") {
      setPreLoanRefNum(null);
      setTextarea("");
    }
  };

  let documents_lst = [];
  download.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null)
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
      });
  });

  let PreloanfilteredLoanRef = [];

  {
    preLoandata.map((ldata) => {
      if (preloanrefnum == ldata.loan_reference_number) {
        if (preloanrefnum !== undefined) {
          PreloanfilteredLoanRef.push(ldata);
        } else {
          PreloanfilteredLoanRef.push("-");
        }
      }
    });
  }

  let selectedobjData = PreloanfilteredLoanRef[0];
  let newServiceObj = {
    loan_documents: documents_lst,
    service_type_code: SERVICE_REQUEST_PRE_CLOSURE,
    business_id: selectedobjData?.business_id,
    user_id: selectedobjData?.user_id,
    loan_id: selectedobjData?.loan_id,
    loan_type_id: selectedobjData?.loan_type_id,
    loan_purpose: selectedobjData?.loan_purpose,
    loan_amount: selectedobjData?.loan_amount,
    loan_currency: selectedobjData?.admin_request_loan_currency,
    loan_tenure: selectedobjData?.loan_tenure,
    monthly_profit_rate: "" + selectedobjData?.bennefin_roi,
    principal_frequency: "" + selectedobjData?.principal_frequency,
    loan_reference_number: selectedobjData?.loan_reference_number,
    extend_tenure: 0,
    created_by: Cookies.get("user_name"),
    notes: textarea,
    preclosure_date:preClosureDate
  };

  return (
    <>
    
      <div className="row ">
      
        <div className="">
          <h6 className="mb-0 mt-2">Current Loan Details</h6>
          <div className="row d-flex gap-1 row-cols-3">
            <div className="col-lg-2 m-2">
              <label htmlFor="loanrefno">
                <p>
                  Loan Reference No.<span style={{ color: "red" }}>*</span>
                </p>
              </label>
              <select
                id="loanrefno"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="loanrefno"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option >Select</option>
                {serviceCode == SERVICE_REQUEST_PRE_CLOSURE ? (
                  preLoandata.map((l_data) => {
                    if (l_data.status == STATUS_PROCESSED && l_data.is_preclosure_raised == 0 && !l_data.is_multi_investor) {
                      return (
                        <option key={l_data.loan_id}>
                          {l_data.loan_reference_number}
                        </option>
                      );
                    }
                  })
                ) : (
                  <option>Select</option>
                )}
              </select>
              {hasMultiInvestorLoan(preLoandata) && (
                <p style={{ fontSize: 11.5, color: "#7C8495", marginTop: 4, marginBottom: 0 }}>
                  {MULTI_INVESTOR_NOTE}
                </p>
              )}
            </div>
            <div className="col-lg-3 m-2">
              <label htmlFor="loantype">
                <p>Loan Type</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={PreloanfilteredLoanRef[0]?.loan_type_name}
              />
            </div>
            <form className="col-lg m-2">
              <label htmlFor="loanamount">
                <p>Loan Amount</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={
                  PreloanfilteredLoanRef[0]?.loan_amount !== undefined
                    ? PreloanfilteredLoanRef[0]?.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                      ? "BHD " +
                      PreloanfilteredLoanRef[0]?.loan_amount
                      : "$\u00A0" + PreloanfilteredLoanRef[0]?.loan_amount
                    : "-"
                }
              />
            </form>
            <form className="col-sm-3 m-2">
              <label htmlFor="tenure">
                <p>Tenure</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={`${PreloanfilteredLoanRef[0]?.admin_request_loan_tenure !=
                  undefined
                  ? PreloanfilteredLoanRef[0]?.admin_request_loan_tenure +
                  (PreloanfilteredLoanRef[0]?.admin_request_loan_tenure == 1
                    ? " Month"
                    : " Months")
                  : ""
                  }`}
              />
            </form>
            <form className="col-lg-3 m-2">
              <label htmlFor="loanpurpose">
                <p>Loan Purpose</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control"
                placeholder={
                  PreloanfilteredLoanRef[0]?.loan_purpose != undefined
                    ? PreloanfilteredLoanRef[0].loan_purpose
                    : ""
                }
              />
            </form>
            <form className="col-lg-2 m-2">
              <label htmlFor="monthlyprofitrate">
                <p>Monthly Rate</p>
              </label>
              <input
                disabled
                type="text"
                id="disabledTextInput"
                className="form-control select_custom_style"
                placeholder={
                  PreloanfilteredLoanRef[0]?.bennefin_roi != null
                    ? PreloanfilteredLoanRef[0]?.bennefin_roi + "%"
                    : ""
                }
              />
            </form>
            <div className="form-group  custm_brdr">
              <label htmlFor="paiddate">
                <p>
                  Select Preclosure Date <span style={{ color: "red" }}>*</span>
                </p>
              </label>
              <input
                name="paiddate"
                id="paiddate"
                type="date"
                className="form-control rounded payemnt_details_BS_form_conrtl"
                onChange={handleChangeInputDate}
              />
            </div>
          </div>
        </div>
        <div>
          <h6 className="mb-1">Notes</h6>
          <Form className="mb-5">
            <Form.Group className=" " controlId="exampleForm.ControlTextarea1">
              <Form.Control
                size="sm"
                className="ANLtextarea"
                name="textarea"
                as="textarea"
                rows={2}
                placeholder="Please Enter your comments for any special requests or providing information to the Admin"
                onChange={handleChangeInput}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
      <Modal.Footer className="prefooter">
        <button
          className="btn gray_btn px-3 py-1"
          variant="secondary"
          onClick={props.handleClose}
        >
          Close
        </button>
        <button
          className="btn blue_btn px-3 py-1"
          variant="primary"
          onClick={handlePreSubmit}
        >
          Send Closure Request
        </button>
      </Modal.Footer>
    </>
  );
};

export const ServiceType = (props) => {
  let preClosureValue = props.setPreClosure;
  let extendTenureValue = props.setExtendTenure;
  let partialPrePayment = props.setPartialPrePayment;

  const handleSeriveType = (e) => {
    props.setSelectedServiceTypeCode(e.target.value);
    if (e.target.value == SERVICE_REQUEST_PRE_CLOSURE) {
      props.setLoanRefNum(null);
      props.setPrepaymentRefNum(null);
      props.months.push("");
      preClosureValue("d-block");
      extendTenureValue("d-none");
      partialPrePayment("d-none");
      props.setDatevalue("");
    }
    if (e.target.value == SERVICE_REQUEST_EXTEND_TENURE) {
      props.setPreLoanRefNum(null);
      props.setPrepaymentRefNum(null);

      preClosureValue("d-none");
      extendTenureValue("d-block");
      partialPrePayment("d-none");
    }
    if (e.target.value == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
      props.setLoanRefNum(null);
      props.setPreLoanRefNum(null)
      props.months.push("");
      preClosureValue("d-none");
      extendTenureValue("d-none");
      partialPrePayment("d-block");
    }
  };

  return (
    <div className="col-lg-3 ">
      <label htmlFor="servicename">
        <p>
          Service type <span style={{ color: "red" }}>*</span>
        </p>
      </label>
      <select
        id="servicename"
        className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
        aria-label="form-select example"
        name="servicename"
        autoComplete="off"
        onChange={handleSeriveType}
        defaultValue={SERVICE_REQUEST_EXTEND_TENURE}
      >
        {props.servicetype.map((s_type, index) => {
          return (
            <option
              value={s_type.service_type_code}
              key={s_type.service_type_code}
            >
              {s_type.service_type_name}
            </option>
          );
        })}
      </select>
    </div>
  );
};
